import PropTypes from "prop-types";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import EmptyState from "@components/shared/elements/empty-state";

export const NoResultText = ({ query }) => {
  const { t } = useTranslation();
  return (
    <EmptyState
      size="medium"
      icon={faMagnifyingGlass}
      title={t("search.noResults", { query })}
      subtitle={t("search.noResultsHint")}
      sx={{ px: 2 }}
    />
  );
};

NoResultText.propTypes = {
  query: PropTypes.string.isRequired,
};
